import ImagesApi from '../services/ImagesApiService';
import Analytics from '../services/Analytics';
import Utils from '../Utils';

class File {
	constructor(key, name, size, compressionMode) {
		this.key = key;
		this.name = name;
		this.size = size;
		this.sizeFormatted = Utils.formatLength(size);
		this.compressedSize = 0;
		this.compressedSizeFormatted = 0;
		this.url = undefined;
		this.originalFilePath = undefined;
		this.percentageCompression = undefined;
		this.compressionMode = compressionMode;
		this.displayWidth = 0;
		this.displayHeight = 0;
		this.subscribers = [];
		this.progressSubscribers = [];
		this.progress = 0;
	}
	get isCompressed() {
		// eslint-disable-next-line no-useless-escape
		const regex = new RegExp(/^((\\|\/)[a-z0-9\s_@\-^!#$%&+={}\[\]]+)+\.[a-z0-9\-_.]*$/i);
		return regex.test(this.url);
	}
	recompress = async mode => {
		const response = await ImagesApi.Recompress(this.name, mode);
		Analytics.onRecompress();
		this.compressionMode = mode;
		this.updateFromResponse(response.data);
		return response;
	}
	updateProgress = progress => {
		this.progress = progress;
		this.progressSubscribers.forEach(fn => {
			fn(progress);
		});
	}
	updateFromResponse = response => {
		const file = response.files[0];
		this.url = file.compressedFilePath;
		this.originalFilePath = file.originalFilePath;
		this.percentageCompression = response.percentageCompression;
		this.compressedSize = file.length;
		this.compressedSizeFormatted = Utils.formatLength(file.length);
		// this.displayWidth = file.width / window.devicePixelRatio;
		// this.displayHeight = file.height / window.devicePixelRatio;
		this.subscribers.forEach(fn => {
			fn(this);
		});
	}
	subscribeForProgress = fn => {
		if (typeof fn === 'function' && !this.subscribers.includes(fn)) {
			this.progressSubscribers.push(fn);
		}
	}
	subscribe = fn => {
		if (typeof fn === 'function' && !this.subscribers.includes(fn)) {
			this.subscribers.push(fn);
		}
	}
	unsubscribe = fn => {
		this.subscribers = this.subscribers.filter(
			item => { return fn !== item; }
		);
	}
}

export default File;



// WEBPACK FOOTER //
// ./src/models/File.js